/**
 * Increment when {@link migrateBlotterStateToPanelParams} changes so configs with
 * older/missing version re-run the migration.
 */
export const BLOTTER_STATE_PANEL_PARAMS_MIGRATION_VERSION = 2;

/** Run migration when stored version is missing or below current version. */
export function shouldRunBlotterStatePanelMigration(config: { blotterStatePanelMigrationVersion?: number }): boolean {
  const v = config.blotterStatePanelMigrationVersion;
  return v == null || v < BLOTTER_STATE_PANEL_PARAMS_MIGRATION_VERSION;
}
